var map = {
	"./cene di gala/path.json": 5855,
	"./congressi & convention/path.json": 1976,
	"./eventi/path.json": 5275,
	"./fiere & showroom/path.json": 1611
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9866;
module.exports = webpackAsyncContext;